import { Steps } from 'antd'
import React from 'react'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import { EMP_CHECK_LIST_NEW } from '../../../../router/routes'

export default function StapMainLayout({ current }) {
  let [searchParams, setSearchParams] = useSearchParams()
  const org = searchParams.get('org')
  const code = searchParams.get('code')
  const id = searchParams.get('id')
  const status = searchParams.get('status')
  const nevigate = useNavigate()

  const onChange = (value) => {
    nevigate(
      {
        pathname: `${EMP_CHECK_LIST_NEW}/stap-${value}`,
        search: `?${createSearchParams({
          code,
          org,
          id,
          stap: value ,
          status
        })}`
      },
      { replace: true }
    )
  }
  return (
    <Steps
      className="bg-white "
      current={current}
      percent={99}
      onChange={onChange}
      labelPlacement="vertical"
      items={[
        {
          title: 'PD',
          disabled: current <= 0
        },
        {
          title: 'IT Asset',
          disabled: current <= 1
        },
        {
          title: 'IT',
          disabled: current <= 2
        },
        {
          title: 'ปฐมนิเทศ',
          disabled: current <= 3
        },
        {
          title: 'Manager',
          disabled: current <= 4
        }
      ]}
    />
  )
}
